/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { SdsDivProps } from '../Component.props';
import { DataListItem } from './DataList.defs';

/**
 * The props for `<DataList />`.
 */
export interface DataListProps extends SdsDivProps {
  /**
   * The message to display if no items are present.
   */
  empty: React.ReactNode;

  /**
   * The header content of the data list.
   */
  headerContent?: JSX.Element;

  /**
   * Specify if the items can be clicked. The onClick event will be defined via an optional action property.
   */
  isInteractive: boolean;

  /**
   * Specify if the lite display version is used.
   */
  isLite?: boolean;

  /**
   * List of items.
   */
  items: Array<DataListItem>;

  /**
   * Specify the limit of items to show. Use -1 for no limit.
   */
  limit?: number;

  /**
   * Toggle the display of the header.
   */
  showHeader?: boolean;

  /**
   * The title of the data list.
   */
  title?: string;

  /**
   * The content for the "show more" button.
   */
  showMoreText?: string;
}

/**
 * The default prop values for `<DataList />`.
 */
export const dataListDefaults = {
  isLite: false,
  limit: -1,
  showHeader: true,
  showMoreText: `Show more`,
};
